const { __, __x } = JIX.Gettext;
const { sitename } = window.Stash.common;

export default {
    title: () => __("Du har fået en mail!"),
    line1: (email) =>
        __x('Vi har sendt dig en mail på adressen <strong:{email}>.', { email }),
    line2: (email) =>
        __x('Denne mail indeholder et link, der aktiverer din Jobagent på {sitename}. For at bekræfte, at du rent faktisk har e-mailadressen <strong:{email}> skal du nu åbne din e-mail og klikke på dette link.', { email, sitename }),
    line3: () =>
        __('Du vil også blive bedt om at oprette en brugerprofil, hvis du ikke allerede er oprettet.'),
};
